import React, { Component } from "react";
import PropTypes from "prop-types";
import "./SliderWithPercent.style.scss";

class SliderWithPercent extends Component {
  state = {
    initialMin: "",
    initialMax: "",
    inputValueMin: "",
    inputValueMax: "",
    inputValueMinPercentage: "",
    inputValueMaxPercentage: ""
  };
  componentDidMount() {
    let { min, max, minMaxZeroToHundred } = this.props;

    let MIN = min < 0 ? 0 : min;
    let MAX = max * 1;
    //minMaxZeroToHundred - if true set min as 0 and max as 100
    // else its value
    let percentMin = minMaxZeroToHundred
      ? this.perCalc({
          min: 0,
          max: 100,
          value: MIN,
        })
      : this.perCalc({
          min: MIN,
          max: MAX,
          value: MIN,
        });

    let percentMax = minMaxZeroToHundred
      ? this.perCalc({
          min: 0,
          max: 100,
          value: MAX,
        })
      : this.perCalc({
          min: MIN,
          max: MAX,
          value: MAX,
        });
    this.setState({
      initialMin: minMaxZeroToHundred ? 0 : MIN,
      initialMax: minMaxZeroToHundred ? 100 : MAX,
      inputValueMin: MIN,
      inputValueMax: max > 100 ? 100 : max,
      inputValueMinPercentage: percentMin,
      inputValueMaxPercentage: percentMax,
    });
  }
  componentWillReceiveProps(nextProps) {
    let { min, max } = nextProps;
    // this.setState({
    //   inputValueMin: min < 0 ? 0 : min,
    //   inputValueMax: max > 100 ? 100 : max,
    // });

    // let prevIdandCurrId =
    //   JSON.stringify(this.props.ID) === JSON.stringify(nextProps.ID);

    // if (prevIdandCurrId === false) {
    //   let MIN = min < 0 ? 0 : min;
    //   let MAX = max * 1;
    //   let percentMin = minMaxZeroToHundred
    //     ? this.perCalc({
    //         min: 0,
    //         max: 100,
    //         value: MIN,
    //       })
    //     : this.perCalc({
    //         min: MIN,
    //         max: MAX,
    //         value: MIN,
    //       });

    //   let percentMax = minMaxZeroToHundred
    //     ? this.perCalc({
    //         min: 0,
    //         max: 100,
    //         value: MAX,
    //       })
    //     : this.perCalc({
    //         min: MIN,
    //         max: MAX,
    //         value: MAX,
    //       });
    //   this.setState({
    //     initialMin: minMaxZeroToHundred ? 0 : MIN,
    //     initialMax: minMaxZeroToHundred ? 100 : MAX,
    //     inputValueMin: MIN,
    //     inputValueMax: max > 100 ? 100 : max,
    //     inputValueMinPercentage: percentMin,
    //     inputValueMaxPercentage: percentMax,
    //   });
    // }
    if (this.props.max !== nextProps.max && this.props.min !== nextProps.min) {
      let MIN = min < 0 ? 0 : min;
      let MAX = max * 1;

      this.setState({
        inputValueMin: MIN,
        inputValueMax: MAX > 100 ? 100 : MAX,
      });
    }
  }

  perCalc = ({ min, max, value }) => {
    let range = max - min;
    let per = ((value - min) * 100) / range;
    return per;
  };

  handlerOne = (e) => {
    let { ID, group, Sliderhandler, name } = this.props;
    let { value } = e.target;
    if (value <= this.state.inputValueMax * 1) {
      let percent = this.perCalc({
        min: this.state.initialMin,
        max: this.state.initialMax,
        value,
      });
      let p = percent > 100 ? 100 : percent < 0 ? 0 : percent;
      let parentDiv = document.getElementById(ID).childNodes[0];
      // input field value
      this.setState({
        inputValueMinPercentage: p,
        inputValueMin: value.toString(),
      });
      // changing left grey indicator color
      parentDiv.childNodes[0].style.width = `${p}%`;
      // moving thumb
      parentDiv.childNodes[3].style.left = `${p}%`;

      // label
      // parentDiv.childNodes[5].style.left = `${value}%`;
      // inner range
      parentDiv.childNodes[2].style.left = `${p}%`;

      let MAX = this.state.inputValueMax * 1 ? this.state.inputValueMax * 1 : 0;
      let obj = {
        min: value * 1,
        max: MAX,
        id: ID,
        group,
        name,
      };

      Sliderhandler(obj);
    }
  };

  handlerTwo = (e) => {
    let { ID, group, Sliderhandler, name } = this.props;
    let { value } = e.target;
    let { initialMax } = this.state;

    let percent = this.perCalc({
      min: this.state.initialMin,
      max: this.state.initialMax,
      value,
    });
    let p = percent > 100 ? 100 : percent < 0 ? 0 : percent;

    if (value >= this.state.inputValueMin * 1) {
      let parentDiv = document.getElementById(ID).childNodes[0];

      // input field value
      this.setState({
        inputValueMaxPercentage: p,
        inputValueMax: value.toString(),
      });
      // changing left grey indicator color
      parentDiv.childNodes[1].style.width = `${p}%`;
      // moving thumb
      parentDiv.childNodes[4].style.left = `${p}%`;

      // label
      // parentDiv.childNodes[6].style.left = `${value}%`;
      // inner range
      parentDiv.childNodes[2].style.right = `${100 - p}%`;

      let MIN = this.state.inputValueMin * 1 ? this.state.inputValueMin : 0;
      let obj = {
        min: MIN * 1,
        max: value * 1,
        id: ID,
        group,
        name,
      };

      Sliderhandler(obj);
    }else{
      this.setState({
        inputValueMax: this.state.initialMax
      });    
      let MIN = this.state.inputValueMin * 1 ? this.state.inputValueMin : 0;
      let obj = {
        min: MIN * 1,
        max: this.state.initialMax,
        id: ID,
        group,
        name,
      };
      Sliderhandler(obj);        
    }
  };
  render() {
    const { ID, bg_warning, steps } = this.props;
    const {
      inputValueMin,
      inputValueMax,
      initialMin,
      initialMax,
      inputValueMinPercentage,
      inputValueMaxPercentage,
    } = this.state;

    return (
      <div className="slider-with-percent">
        <span>Min</span>
        <input
            type="number"
            tabIndex="1"
            step="1"
            value={inputValueMin}
            onChange={(e) => this.handlerOne(e)}
            className="range-input-tf"
          />
        <div id={ID} className="slider-with-percent__dual-slider">
          <div>
            {/* external grey not filled one */}
            <div
              style={{ width: `${inputValueMinPercentage}%` }}
              className="inverse-left"
            />
            <div
              style={{ width: `${100 - inputValueMaxPercentage}%` }}
              className="inverse-right"
            />
            {/* inner color */}
            <div
              style={{
                left: `${inputValueMinPercentage}%`,
                right: `${100 - inputValueMaxPercentage}%`,
              }}
              className={`range ${bg_warning ? "bg-error" : ""}  `}
            />
            {/* thumbs */}
            <span
              style={{ left: `${inputValueMinPercentage}%` }}
              className={`thumb ${bg_warning ? "bg-error" : ""}  `}
            >
              {inputValueMin === 0
                ? 0
                : inputValueMin * 1 < 1
                ? (inputValueMin * 1).toFixed(2)
                : (inputValueMin * 1).toFixed()}
              %
            </span>
            <span
              style={{ left: `${inputValueMaxPercentage}%` }}
              className={`thumb ${bg_warning ? "bg-error" : ""}  `}
            >
              {inputValueMax === 0
                ? 0
                : inputValueMax * 1 < 1
                ? (inputValueMax * 1).toFixed(2)
                : (inputValueMax * 1).toFixed()}
              %
            </span>
            {/* labels */}
            {/* <div style={{ left: `${inputValueMin}%` }} className="sign">
              <span id="value">{(inputValueMin * 1).toFixed()}</span>
            </div>
            <div style={{ left: `${inputValueMax}%` }} className="sign">
              <span id="value">{(inputValueMax * 1).toFixed()}</span>
            </div> */}
          </div>
          <input
            type="range"
            tabIndex="0"
            min={initialMin}
            max={initialMax}
            step={steps}
            value={inputValueMin}
            onChange={(e) => this.handlerOne(e)}
          />
          <input
            type="range"
            tabIndex="0"
            min={initialMin}
            max={initialMax}
            value={inputValueMax}
            step={steps}
            onChange={(e) => this.handlerTwo(e)}
          />
        </div>
        <input
            type="number"
            tabIndex="2"
            value={inputValueMax}
            step="1"
            onChange={(e) => this.handlerTwoTemp(e)}
            onBlur={(e) => this.handlerTwo(e)}
            className="range-input-tf"
          />     

        <span>Max</span>
      </div>
    );
  }
}

SliderWithPercent.defaultProps = {
  steps: 1,
};
SliderWithPercent.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  bg_warning: PropTypes.bool,
  minMaxZeroToHundred: PropTypes.bool,
  steps: PropTypes.number,
};

export default SliderWithPercent;



// WEBPACK FOOTER //
// ./src/components/common/sliderWithPercent/SliderWithPercent.jsx